import { Routes, Route} from "react-router";
import Navbar from "./Components/Navbar";
import LandingPage from "./Pages/LandingPage";
import Products from "./Components/Products";
import About from "./Components/About";
import ContactPage from "./Components/ContactPage";

function App() {
 
  return (
    <>
      <Routes>
        <Route path="/" element={<LandingPage/>} />
        <Route path="/products" element={<Products/>}/>
        <Route path="/about" element={<About/>}/>
        <Route path="/contact" element={<ContactPage/>}/>
      </Routes>
    </>
  );
}

export default App;
